// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stroke-analysis {
  position: fixed;
  inset: 0;
  z-index: 12070;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  pointer-events: none;
}

.stroke-analysis__backdrop {
  position: absolute;
  inset: 0;
  border: 0;
  background: rgba(2, 6, 23, 0.32);
  pointer-events: auto;
}

.stroke-analysis__sheet {
  position: relative;
  pointer-events: auto;
  width: min(560px, 100%);
  max-height: min(72vh, 640px);
  overflow: auto;
  margin: 0 10px max(10px, env(safe-area-inset-bottom, 0px));
  padding: 14px 14px 16px;
  border-radius: 18px;
  background: rgba(15, 23, 42, 0.96);
  color: #f8fafc;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.stroke-analysis__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.stroke-analysis__eyebrow {
  margin: 0 0 4px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #93c5fd;
}

.stroke-analysis__title {
  margin: 0;
  font-size: 1.15rem;
  letter-spacing: -0.02em;
}

.stroke-analysis__meta {
  margin: 4px 0 0;
  font-size: 0.78rem;
  color: rgba(248, 250, 252, 0.72);
}

.stroke-analysis__close {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  cursor: pointer;
}

.stroke-analysis__filters {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0 0 10px;
}

.stroke-analysis__filters button {
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  padding: 5px 10px;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(248, 250, 252, 0.85);
  font-size: 0.72rem;
  font-weight: 650;
  cursor: pointer;
}

.stroke-analysis__filters button.is-on {
  background: rgba(59, 130, 246, 0.28);
  border-color: rgba(147, 197, 253, 0.55);
  color: #fff;
}

.stroke-analysis__list {
  list-style: none;
  margin: 0 0 10px;
  padding: 0;
  max-height: 140px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stroke-analysis__list button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 8px 10px;
  background: rgba(255, 255, 255, 0.04);
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.stroke-analysis__list button strong {
  font-size: 0.82rem;
  font-weight: 650;
}

.stroke-analysis__list button span {
  font-size: 0.74rem;
  font-variant-numeric: tabular-nums;
  color: rgba(248, 250, 252, 0.65);
}

.stroke-analysis__list button.is-on {
  background: rgba(59, 130, 246, 0.22);
  border-color: rgba(147, 197, 253, 0.4);
}

.stroke-analysis__nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 12px;
}

.stroke-analysis__play {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 4px;
  border: 1px solid rgba(52, 211, 153, 0.45);
  border-radius: 999px;
  padding: 7px 12px;
  background: rgba(16, 185, 129, 0.22);
  color: #ecfdf5;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
}

.stroke-analysis__play:disabled {
  opacity: 0.35;
  cursor: default;
}

.stroke-analysis__play:not(:disabled):hover {
  background: rgba(16, 185, 129, 0.35);
}

.stroke-analysis__nav-btn {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
  cursor: pointer;
}

.stroke-analysis__nav-btn:disabled {
  opacity: 0.35;
  cursor: default;
}

.stroke-analysis__nav-label {
  font-size: 0.8rem;
  font-weight: 650;
  font-variant-numeric: tabular-nums;
  color: rgba(248, 250, 252, 0.8);
}

.stroke-analysis__empty {
  margin: 8px 0 0;
  padding: 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(248, 250, 252, 0.78);
  font-size: 0.88rem;
  line-height: 1.45;
}

.stroke-analysis__timeline {
  display: flex;
  gap: 4px;
  margin: 0 0 12px;
  min-height: 48px;
}

.stroke-analysis__phase-chip {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;
  min-width: 0;
  padding: 6px 8px;
  border: 0;
  border-radius: 10px;
  color: #0f172a;
  cursor: pointer;
  text-align: left;
}

.stroke-analysis__phase-chip-label {
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.stroke-analysis__phase-chip-dur {
  font-size: 0.72rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.stroke-analysis__phase-chip--preparation {
  background: #93c5fd;
}

.stroke-analysis__phase-chip--forward_swing {
  background: #86efac;
}

.stroke-analysis__phase-chip--contact {
  background: #fde047;
}

.stroke-analysis__phase-chip--follow_through {
  background: #fdba74;
}

.stroke-analysis__phase-chip--recovery {
  background: #c4b5fd;
}

.stroke-analysis__phases {
  list-style: none;
  margin: 0 0 14px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stroke-analysis__phase-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  padding: 8px 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.stroke-analysis__phase-main {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
  padding: 0;
}

.stroke-analysis__phase-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  flex-shrink: 0;
}

.stroke-analysis__phase-dot--preparation {
  background: #60a5fa;
}

.stroke-analysis__phase-dot--forward_swing {
  background: #4ade80;
}

.stroke-analysis__phase-dot--contact {
  background: #facc15;
}

.stroke-analysis__phase-dot--follow_through {
  background: #fb923c;
}

.stroke-analysis__phase-dot--recovery {
  background: #a78bfa;
}

.stroke-analysis__phase-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.stroke-analysis__phase-copy strong {
  font-size: 0.88rem;
}

.stroke-analysis__phase-copy em {
  font-style: normal;
  font-size: 0.72rem;
  color: rgba(248, 250, 252, 0.62);
  font-variant-numeric: tabular-nums;
}

.stroke-analysis__angles {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 0.72rem;
  font-weight: 650;
  font-variant-numeric: tabular-nums;
  color: rgba(248, 250, 252, 0.85);
  text-align: right;
}

.stroke-analysis__tips h3 {
  margin: 0 0 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #fde68a;
}

.stroke-analysis__tips ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stroke-analysis__tip {
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
}

.stroke-analysis__tip strong {
  display: block;
  font-size: 0.86rem;
  margin-bottom: 3px;
}

.stroke-analysis__tip p {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.4;
  color: rgba(248, 250, 252, 0.78);
}

.stroke-analysis__tip--warn {
  border-color: rgba(251, 146, 60, 0.45);
  background: rgba(251, 146, 60, 0.1);
}

.stroke-analysis__tip--ok {
  border-color: rgba(74, 222, 128, 0.4);
  background: rgba(74, 222, 128, 0.08);
}

.stroke-analysis__tip--info {
  border-color: rgba(96, 165, 250, 0.4);
  background: rgba(96, 165, 250, 0.08);
}
`, "",{"version":3,"sources":["webpack://./src/components/StrokeAnalysisPanel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;EACd,0DAA0D;EAC1D,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;EACpB,iBAAiB;EACjB,qCAAqC;EACrC,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,0CAA0C;EAC1C,oBAAoB;EACpB,iBAAiB;EACjB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,oBAAoB;EACpB,qCAAqC;EACrC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC","sourcesContent":[".stroke-analysis {\n  position: fixed;\n  inset: 0;\n  z-index: 12070;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.stroke-analysis__backdrop {\n  position: absolute;\n  inset: 0;\n  border: 0;\n  background: rgba(2, 6, 23, 0.32);\n  pointer-events: auto;\n}\n\n.stroke-analysis__sheet {\n  position: relative;\n  pointer-events: auto;\n  width: min(560px, 100%);\n  max-height: min(72vh, 640px);\n  overflow: auto;\n  margin: 0 10px max(10px, env(safe-area-inset-bottom, 0px));\n  padding: 14px 14px 16px;\n  border-radius: 18px;\n  background: rgba(15, 23, 42, 0.96);\n  color: #f8fafc;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.45);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n}\n\n.stroke-analysis__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.stroke-analysis__eyebrow {\n  margin: 0 0 4px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.68rem;\n  font-weight: 750;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #93c5fd;\n}\n\n.stroke-analysis__title {\n  margin: 0;\n  font-size: 1.15rem;\n  letter-spacing: -0.02em;\n}\n\n.stroke-analysis__meta {\n  margin: 4px 0 0;\n  font-size: 0.78rem;\n  color: rgba(248, 250, 252, 0.72);\n}\n\n.stroke-analysis__close {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  border: 0;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n  cursor: pointer;\n}\n\n.stroke-analysis__filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 0 0 10px;\n}\n\n.stroke-analysis__filters button {\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 999px;\n  padding: 5px 10px;\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(248, 250, 252, 0.85);\n  font-size: 0.72rem;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.stroke-analysis__filters button.is-on {\n  background: rgba(59, 130, 246, 0.28);\n  border-color: rgba(147, 197, 253, 0.55);\n  color: #fff;\n}\n\n.stroke-analysis__list {\n  list-style: none;\n  margin: 0 0 10px;\n  padding: 0;\n  max-height: 140px;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.stroke-analysis__list button {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  padding: 8px 10px;\n  background: rgba(255, 255, 255, 0.04);\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.stroke-analysis__list button strong {\n  font-size: 0.82rem;\n  font-weight: 650;\n}\n\n.stroke-analysis__list button span {\n  font-size: 0.74rem;\n  font-variant-numeric: tabular-nums;\n  color: rgba(248, 250, 252, 0.65);\n}\n\n.stroke-analysis__list button.is-on {\n  background: rgba(59, 130, 246, 0.22);\n  border-color: rgba(147, 197, 253, 0.4);\n}\n\n.stroke-analysis__nav {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.stroke-analysis__play {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: 4px;\n  border: 1px solid rgba(52, 211, 153, 0.45);\n  border-radius: 999px;\n  padding: 7px 12px;\n  background: rgba(16, 185, 129, 0.22);\n  color: #ecfdf5;\n  font-size: 0.78rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.stroke-analysis__play:disabled {\n  opacity: 0.35;\n  cursor: default;\n}\n\n.stroke-analysis__play:not(:disabled):hover {\n  background: rgba(16, 185, 129, 0.35);\n}\n\n.stroke-analysis__nav-btn {\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.06);\n  color: #fff;\n  cursor: pointer;\n}\n\n.stroke-analysis__nav-btn:disabled {\n  opacity: 0.35;\n  cursor: default;\n}\n\n.stroke-analysis__nav-label {\n  font-size: 0.8rem;\n  font-weight: 650;\n  font-variant-numeric: tabular-nums;\n  color: rgba(248, 250, 252, 0.8);\n}\n\n.stroke-analysis__empty {\n  margin: 8px 0 0;\n  padding: 12px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(248, 250, 252, 0.78);\n  font-size: 0.88rem;\n  line-height: 1.45;\n}\n\n.stroke-analysis__timeline {\n  display: flex;\n  gap: 4px;\n  margin: 0 0 12px;\n  min-height: 48px;\n}\n\n.stroke-analysis__phase-chip {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 2px;\n  min-width: 0;\n  padding: 6px 8px;\n  border: 0;\n  border-radius: 10px;\n  color: #0f172a;\n  cursor: pointer;\n  text-align: left;\n}\n\n.stroke-analysis__phase-chip-label {\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.stroke-analysis__phase-chip-dur {\n  font-size: 0.72rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.stroke-analysis__phase-chip--preparation {\n  background: #93c5fd;\n}\n\n.stroke-analysis__phase-chip--forward_swing {\n  background: #86efac;\n}\n\n.stroke-analysis__phase-chip--contact {\n  background: #fde047;\n}\n\n.stroke-analysis__phase-chip--follow_through {\n  background: #fdba74;\n}\n\n.stroke-analysis__phase-chip--recovery {\n  background: #c4b5fd;\n}\n\n.stroke-analysis__phases {\n  list-style: none;\n  margin: 0 0 14px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.stroke-analysis__phase-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 8px;\n  align-items: center;\n  padding: 8px 10px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.stroke-analysis__phase-main {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n  padding: 0;\n}\n\n.stroke-analysis__phase-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n  flex-shrink: 0;\n}\n\n.stroke-analysis__phase-dot--preparation {\n  background: #60a5fa;\n}\n\n.stroke-analysis__phase-dot--forward_swing {\n  background: #4ade80;\n}\n\n.stroke-analysis__phase-dot--contact {\n  background: #facc15;\n}\n\n.stroke-analysis__phase-dot--follow_through {\n  background: #fb923c;\n}\n\n.stroke-analysis__phase-dot--recovery {\n  background: #a78bfa;\n}\n\n.stroke-analysis__phase-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.stroke-analysis__phase-copy strong {\n  font-size: 0.88rem;\n}\n\n.stroke-analysis__phase-copy em {\n  font-style: normal;\n  font-size: 0.72rem;\n  color: rgba(248, 250, 252, 0.62);\n  font-variant-numeric: tabular-nums;\n}\n\n.stroke-analysis__angles {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 0.72rem;\n  font-weight: 650;\n  font-variant-numeric: tabular-nums;\n  color: rgba(248, 250, 252, 0.85);\n  text-align: right;\n}\n\n.stroke-analysis__tips h3 {\n  margin: 0 0 8px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.78rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #fde68a;\n}\n\n.stroke-analysis__tips ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.stroke-analysis__tip {\n  padding: 10px 12px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.stroke-analysis__tip strong {\n  display: block;\n  font-size: 0.86rem;\n  margin-bottom: 3px;\n}\n\n.stroke-analysis__tip p {\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 1.4;\n  color: rgba(248, 250, 252, 0.78);\n}\n\n.stroke-analysis__tip--warn {\n  border-color: rgba(251, 146, 60, 0.45);\n  background: rgba(251, 146, 60, 0.1);\n}\n\n.stroke-analysis__tip--ok {\n  border-color: rgba(74, 222, 128, 0.4);\n  background: rgba(74, 222, 128, 0.08);\n}\n\n.stroke-analysis__tip--info {\n  border-color: rgba(96, 165, 250, 0.4);\n  background: rgba(96, 165, 250, 0.08);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
